/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';

/**
 * 
 * @export
 * @interface CampaignMoneyDataSource
 */
export interface CampaignMoneyDataSource {
    /**
     * 
     * @type {string}
     * @memberof CampaignMoneyDataSource
     */
    campaignId?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignMoneyDataSource
     */
    campaignRemoteId?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignMoneyDataSource
     */
    campaignName?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignMoneyDataSource
     */
    integrationId?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignMoneyDataSource
     */
    integrationName?: string;
    /**
     * 
     * @type {{ [key: string]: MoneyOutput; }}
     * @memberof CampaignMoneyDataSource
     */
    data?: { [key: string]: MoneyOutput; };
}

/**
 * Check if a given object implements the CampaignMoneyDataSource interface.
 */
export function instanceOfCampaignMoneyDataSource(value: object): value is CampaignMoneyDataSource {
    return true;
}

export function CampaignMoneyDataSourceFromJSON(json: any): CampaignMoneyDataSource {
    return CampaignMoneyDataSourceFromJSONTyped(json, false);
}

export function CampaignMoneyDataSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CampaignMoneyDataSource {
    if (json == null) {
        return json;
    }
    return {
        
        'campaignId': json['campaignId'] == null ? undefined : json['campaignId'],
        'campaignRemoteId': json['campaignRemoteId'] == null ? undefined : json['campaignRemoteId'],
        'campaignName': json['campaignName'] == null ? undefined : json['campaignName'],
        'integrationId': json['integrationId'] == null ? undefined : json['integrationId'],
        'integrationName': json['integrationName'] == null ? undefined : json['integrationName'],
        'data': json['data'] == null ? undefined : (mapValues(json['data'], MoneyOutputFromJSON)),
    };
}

export function CampaignMoneyDataSourceToJSON(json: any): CampaignMoneyDataSource {
    return CampaignMoneyDataSourceToJSONTyped(json, false);
}

export function CampaignMoneyDataSourceToJSONTyped(value?: CampaignMoneyDataSource | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'campaignId': value['campaignId'],
        'campaignRemoteId': value['campaignRemoteId'],
        'campaignName': value['campaignName'],
        'integrationId': value['integrationId'],
        'integrationName': value['integrationName'],
        'data': value['data'] == null ? undefined : (mapValues(value['data'], MoneyOutputToJSON)),
    };
}

